import axios from 'axios';


let configPromise = null;
let BASE_URL = 'https://dandhapi.cellhub.com/'; 


const loadConfig = async () => {
  if (!configPromise) {
    configPromise = new Promise(async (resolve, reject) => {
      try {
   
        const response = await fetch('/config.json');
        const config = await response.json();
        BASE_URL = config.BASE_URL || BASE_URL; 
        resolve(BASE_URL);
      } catch (error) {
        console.error('Error loading config:', error);
        reject(error);
      }
    });
  }
  return configPromise;
};

const ensureConfigLoaded = async () => {
  if (!configPromise) {
    await loadConfig();
  }
  return configPromise;
};

export const GetUrlAndLogo = async (payload) => {
  await ensureConfigLoaded();
  const response = await axios.post(
    `${BASE_URL}validate/PostUrlInfo`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const SubmitEmail = async (payload) => {
  await ensureConfigLoaded();
  const response = await axios.post(
    `${BASE_URL}validate/PostEmailValidate`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const EmailOtp = async (payload) => {
  await ensureConfigLoaded();
  const response = await axios.post(
    `${BASE_URL}validate/PostVerifyOTP`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const SendEmailAndCode = async (payload) => {
  await ensureConfigLoaded();
  const response = await axios.post(
    `${BASE_URL}validate/Postapplication`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const SendStatusEmail = async (payload) => {
  await ensureConfigLoaded();
  const response = await axios.post(
    `${BASE_URL}validate/PostEmailValidateforStatus`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const GetStatusId = async (email) => {
  await ensureConfigLoaded();
  const response = await axios.get(
    `${BASE_URL}validate/GetStatusFromEmail?email=${email}`
  );
  return response;
};

export const GetStatus = async (email) => {
  await ensureConfigLoaded();
  const response = await axios.get(
    `${BASE_URL}validate/GetApplicationStatus?email=${email}`
  );
  return response;
};

export const UpdateStatus = async (payload) => {
  await ensureConfigLoaded();
  const response = await axios.post(
    `${BASE_URL}validate/PostUpdateStatus`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};
